<script>
	export let heading;
	export let subheading;
	export let textColor;
	export let textAlign;
	export let fontSize;
</script>

{#if subheading}
	<h4
		class:white={textColor === 'white'}
		class:left={textAlign === 'left'}
		id={heading.toLowerCase()}
	>
		{subheading}
	</h4>
{/if}
<h1
	class:white={textColor === 'white'}
	class:left={textAlign === 'left'}
	class:md={fontSize === 'md'}
	class:sm={fontSize === 'sm'}
>
	{heading}
</h1>

<style>
	h1,
	h4 {
		text-align: center;
		text-transform: uppercase;
	}

	h4 {
		font-weight: 600;
		letter-spacing: 2px;
		color: #8c8c8c;
		font-size: 1.2rem;
	}

	h1 {
		margin: 2rem 0;
		font-family: 'Oswald', sans-serif;
		font-size: 3.6rem;
		line-height: 1.3;
	}

	h1.md {
		font-size: 2.2rem;
	}

	h1.sm {
		font-size: 1.6rem;
	}

	.left {
		text-align: left;
	}

	h4.white,
	h1.white {
		color: #fff;
	}

	@media screen and (min-width: 350px) {
		h1 {
			font-size: 5.4rem;
		}

		h1.md {
			font-size: 3.2rem;
		}

		h1.sm {
			font-size: 2.4rem;
		}
	}

	@media screen and (min-width: 700px) {
		h1 {
			line-height: 1;
		}
	}
</style>
